import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout";
import styles from "./document.module.css";
import { CiSearch } from "react-icons/ci";
import { toast } from "react-toastify";
import DocumentCard from "./DocumentCard";
import DocumentModel from "./DocumentModel";
import { DocApi } from "../../../../App/api/document.apis";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import DeleteFieldModal from "../../../../Components/Common/DeleteFieldModal";
import SelectDropdown from "../../../../Components/Dropdown/SelectDropdown";
import debounce from "lodash/debounce";

const Document = ({meta}) => {
  const [editData, setEditData] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const debounceTimeout = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [documentAllData, setDocumentAllData] = useState(null);
  const [documentHasMore, setDocumentHasMore] = useState(null);

  const [isDocModelOpen, setIsDocModelOpen] = useState(false);

  const initialDocumentValues = {
    name: "",
    _id: "",
    user_role: {},
    is_mandatory: false,
    is_visible: false,
    is_expiry_date: false,
    is_unique_code: false,
  };

  const userRole = useFetchAll(() => DocApi.getAllUserRole());

  const getInitialDocument = async (pagination) => {
    setDocumentAllData([]);
    try {
      const res = await DocApi.getAllDocuments(pagination);
      const newData = res?.data?.data?.documentMaster;
      // console.log("res", res);
      setDocumentAllData(newData);
      // console.log("new data", newData);
      setDocumentHasMore(res?.data?.data?.totalCount);
      setPage(page + 1);
    } catch (error) {
      // console.log("Error", error);
    }
  };

  useEffect(() => {
    getInitialDocument({ page: 1, limit: 3 });
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getDocument = async (pagination) => {
    // console.log("page", page);
    // console.log("pagination", pagination);
    try {
      const res = await DocApi.getAllDocuments({ page, limit: 3 }, searchQuery);
      setDocumentHasMore(res?.data?.data?.totalCount);
      const newData = res?.data?.data?.documentMaster;
      setDocumentAllData((prev) =>
        page === 1 ? newData : [...prev, ...newData]
      );
      setPage(page + 1);
    } catch (error) {
      // console.log("error", error);
    }
  };
  const getDocumentSearch = async (query) => {
    // console.log("pagination", query);
    try {
      const res = await DocApi.getAllDocuments({ page: 1, limit: 3 }, query);
      setDocumentHasMore(res?.data?.data?.totalCount);
      const newData = res?.data?.data?.documentMaster;
      setDocumentAllData((prev) =>
        page === 1 ? newData : [...prev, ...newData]
      );
      setPage(page + 1);
    } catch (error) {
      // console.log("error", error);
    }
  };

  // console.log("document all data", documentAllData);

  const userRoleData = Array.isArray(userRole.value?.data)
    ? userRole.value.data
    : [];

  const handleDropBox = (e, name) => {
    // console.log("e", e);
    // console.log("name", name);
    // setDocumentAllData([]);
    getInitialDocument({ page: 1, limit: 4, filter: { user_role: name?._id } });
  };

  const handleDocumentEdit = (item) => {
    setEditData(item);
    setIsDocModelOpen(true);
  };

  const debouncedFetch = useCallback(
    debounce((query) => getDocumentSearch(query), 1000),
    []
  );

  const debouncedSearch = (event) => {
    const query = event.target.value.trim();
    setSearchQuery(query);
    debouncedFetch(query);
  };

  const handleDocumentDelete = useCallback((_id) => {
    setDeleteModal(true);
    setDeleteId(_id);
  }, []);

  const handleDeleteClose = useCallback(() => {
    setDeleteModal(false);
  }, []);

  const handleDelete = useCallback(async () => {
    try {
      if (deleteId !== null) {
        const res = await DocApi.deleteDocument(deleteId);
        toast.success(`${res.data.message}`);
        getInitialDocument({ page: 1, limit: 3 });
      }
    } catch (err) {
      // console.log(err);
    } finally {
      handleDeleteClose();
    }
  }, [deleteId, getDocument, handleDeleteClose]);

  return (
    <>
      <CommonLayout NavClass={`ml-1`}/>
      <div className={styles.subcontainer1}>
        <div className={styles.top_content}>
          <div className="d-flex gap-1 px-6">
            <div className={styles.border_search}>
              <input
                type="search"
                onChange={debouncedSearch}
                style={{
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                }}
                placeholder="Search"
              />
              <CiSearch size={"1.1rem"} />
            </div>
            <SelectDropdown
              placeholder={editData ? editData?.user_role?.name : "Select Type"}
              options={userRoleData}
              handleFilter={(e, v) => handleDropBox(e, v)}
              sx={{border:'1px solid var(--color--11)'}}
            />
          </div>
          <p
            className={styles.p2_border}
            onClick={() => setIsDocModelOpen(true)}
          >
            Add Document
          </p>
        </div>
      </div>
      <div style={{ padding: "2rem" }}>
        <hr />
      </div>
      <div className="flex flex-col justify-center p-5 gap-5 ">
        <div
          className={styles.subcontainer1}
          style={{
            gap: "1.5rem",
            alignItems: "flex-start",
          }}
        >
          {documentAllData?.map((item) => (
            <DocumentCard
              key={item._id}
              item={item}
              userRoleData={userRoleData}
              initialDocumentValues={initialDocumentValues}
              handleDocumentEdit={handleDocumentEdit}
              fetchAllData={() => {}}
              handleDocumentDelete={handleDocumentDelete}
            />
          ))}
        </div>
        {documentHasMore > documentAllData?.length && (
          <button
            className={styles.loadMoreButton}
            onClick={() => getDocument({ page, limit: 4 })}
          >
            Load More
          </button>
        )}
      </div>

      {isDocModelOpen && (
        <DocumentModel
          isdocModel={isDocModelOpen}
          fetchAllData={() => getInitialDocument({ page: 1, limit: 3 })}
          handlecloseDocModel={() => {
            setEditData(null);
            setIsDocModelOpen(false);
          }}
          userRoleData={userRoleData}
          editData={editData}
        />
      )}

      {deleteModal && (
        <DeleteFieldModal
          isOpen={deleteModal}
          onClose={handleDeleteClose}
          onDelete={handleDelete}
        />
      )}
    </>
  );
};

export default Document;
